import { useModal } from '@shared/model/useModal';

export const useAddAppointmentByTeacherModal = () => useModal('add-appointment-by-teacher')